/**
 * Print a QR code by grabbing the SVG from the DOM and sending it to a print-friendly window.
 * @param {string} containerSelector - CSS selector for the container that has the <svg> QR code
 * @param {string} label - Optional label (e.g. staff name)
 * @param {string} url - The URL encoded in the QR
 */
export function printQRFromDOM(containerSelector, label, url) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const svg = container.querySelector('svg');
  if (!svg) return;

  // Clone and resize the SVG for print
  const clone = svg.cloneNode(true);
  clone.setAttribute('width', '280');
  clone.setAttribute('height', '280');

  const svgString = new XMLSerializer().serializeToString(clone);

  const printWindow = window.open('', '_blank', 'width=420,height=550');
  if (!printWindow) return;

  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>QR Code${label ? ' - ' + label : ''}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      padding: 40px;
    }
    .label { font-size: 11px; color: #888; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 1px; }
    .title { font-size: 18px; font-weight: 700; color: #333; margin-bottom: 20px; }
    .qr-wrap { border: 1px solid #eee; padding: 8px; display: inline-block; }
    .url { font-size: 7px; color: #bbb; margin-top: 12px; word-break: break-all; max-width: 300px; text-align: center; font-family: monospace; }
    @media print { body { padding: 20mm; } }
  </style>
</head>
<body>
  ${label ? `<div class="label">${label}</div>` : ''}
  <div class="title">Scan to Pay</div>
  <div class="qr-wrap">${svgString}</div>
  ${url ? `<div class="url">${url}</div>` : ''}
  <script>window.onload = function() { setTimeout(function() { window.print(); }, 200); }<\/script>
</body>
</html>`);
  printWindow.document.close();
}
